import { IStoreState } from '../types';

export const getSubscription = (state: IStoreState) => state.subscription;
